var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.2064L3.64645 13.8529L3.5 13.9993V14.2064H4ZM13.931 4.27539L14.2846 3.92184C14.0893 3.72658 13.7727 3.72658 13.5775 3.92184L13.931 4.27539ZM19.4483 9.79263L19.8018 10.1462C19.9971 9.95092 19.9971 9.63434 19.8018 9.43908L19.4483 9.79263ZM9.51724 19.7237V20.2237H9.72435L9.87079 20.0772L9.51724 19.7237ZM4 19.7237H3.5C3.5 19.9998 3.72386 20.2237 4 20.2237V19.7237ZM4.35355 14.56L14.2846 4.62894L13.5775 3.92184L3.64645 13.8529L4.35355 14.56ZM13.5775 4.62894L19.0947 10.1462L19.8018 9.43908L14.2846 3.92184L13.5775 4.62894ZM19.0947 9.43908L9.16369 19.3701L9.87079 20.0772L19.8018 10.1462L19.0947 9.43908ZM9.51724 19.2237H4V20.2237H9.51724V19.2237ZM4.5 19.7237V14.2064H3.5V19.7237H4.5ZM10.2671 7.93929L15.7844 13.4565L16.4915 12.7494L10.9742 7.23218L10.2671 7.93929ZM12.2759 20.2237H20V19.2237H12.2759V20.2237Z",
    fill: "#505050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f2f2b6dd6a55dcdbae3e73fed3dc3ab6.svg";
export { ForwardRef as ReactComponent };